import React, { useCallback } from "react";
import BaseGrid from "Components/Fragment/BaseGrid";
import SelectFilterCategory from "./SelectFilterCategory";
import SelectFilterTags from "./SelectFilterTags";

const FilterSection = ({ store, state, setState, languageContext }) => {
  const setTagFilter = useCallback(
    (no, value) => {
      setState((prevState) => {
        const selectedTags = [...prevState.selectedTags];
        selectedTags[no] = value;
        return { ...prevState, selectedTags };
      });
    },
    [setState],
  );

  return (
    <BaseGrid childWidth="auto" direction="column">
      <SelectFilterCategory
        store={store}
        categoryId={state.categoryId}
        onCategoryChange={(categoryId) =>
          setState((prevState) => ({ ...prevState, categoryId }))
        }
        languageContext={languageContext}
        sx={{ maxWidth: "250px !important" }}
      />

      <SelectFilterTags
        store={store}
        setTagFilter={setTagFilter}
        languageContext={languageContext}
        sx={{ maxWidth: "250px !important" }}
      />
    </BaseGrid>
  );
};

export default FilterSection;
